
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M10.25 5.25A.25.25 0 0 1 10 5v-.5a.25.25 0 0 1 .25-.25h2a.25.25 0 0 1 .25.25V5a.25.25 0 0 1-.25.25h-2zm4 1.5h-4A.25.25 0 0 1 10 6.5V6a.25.25 0 0 1 .25-.25h4a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25zm-2 7.5h-2A.25.25 0 0 1 10 14v-.5a.25.25 0 0 1 .25-.25h2a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25zm2 .5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-4a.25.25 0 0 1-.25-.25V15a.25.25 0 0 1 .25-.25h4zm0-4.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-4A.25.25 0 0 1 10 11v-.5a.25.25 0 0 1 .25-.25h4zm-2-1.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-2A.25.25 0 0 1 10 9.5V9a.25.25 0 0 1 .25-.25h2zM6.5 15h1v-1h-1v1zm1.625 1h-2.25a.375.375 0 0 1-.375-.375v-2.25c0-.207.168-.375.375-.375h2.25c.207 0 .375.168.375.375v2.25a.375.375 0 0 1-.375.375zM6.5 10.5h1v-1h-1v1zm-.625 1a.375.375 0 0 1-.375-.375v-2.25c0-.207.168-.375.375-.375h2.25c.207 0 .375.168.375.375v2.25a.375.375 0 0 1-.375.375h-2.25zM6.5 6h1V5h-1v1zm-.625 1a.375.375 0 0 1-.375-.375v-2.25c0-.207.168-.375.375-.375h2.25c.207 0 .375.168.375.375v2.25A.375.375 0 0 1 8.125 7h-2.25zM16 17.5H4v-15h12v15zM13.5 1H3.625C3.005 1 2.5 1.512 2.5 2.14v15.72c0 .628.505 1.14 1.125 1.14h12.75c.62 0 1.125-.512 1.125-1.14V2.14c0-.628-.505-1.14-1.125-1.14H13.5z"}})])
          )
        }
      }
    